<section class="post-hearing">
  <header class="post-hearing__header">
    <h1 class="post-hearing__title">{{ pageTitle() }}</h1>
  </header>

  <div class="post-hearing__body">
    <div class="post-hearing__filters" data-testid="filter-controls">
      <label class="post-hearing__filter">
        {{ operationalText.statusFilter() }}
        <input
          type="text"
          name="status"
          [(ngModel)]="filterFormValues.status"
          data-testid="status-input"
        />
      </label>
      <button
        type="button"
        data-testid="apply-button"
        (click)="applyFilters()"
        [disabled]="isLoading()"
      >
        Apply
      </button>
      <button
        type="button"
        data-testid="refresh-button"
        (click)="refresh()"
        [disabled]="isLoading()"
      >
        Refresh
      </button>
    </div>

    <div *ngIf="isLoading()" class="state loading" data-testid="loading-state">
      {{ hearingText.loading() }}
    </div>

    <div
      *ngIf="errorState() as error"
      class="state error"
      data-testid="error-state"
    >
      <strong>{{ error.title }}</strong>
      <p *ngFor="let message of error.messages" class="message">
        {{ message }}
      </p>
    </div>

    <div
      *ngIf="!isLoading() && !hasTasks()"
      class="state"
      data-testid="empty-state"
    >
      {{ hearingText.empty() }}
    </div>

    <table *ngIf="hasTasks()" class="task-table" data-testid="task-table">
      <thead>
        <tr>
          <th>Subject</th>
          <th>Step</th>
          <th>{{ operationalText.statusColumn() }}</th>
          <th>Assignment</th>
          <th>{{ operationalText.queueAndAssignee() }}</th>
          <th>Updated</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let task of tasks(); trackBy: trackByTask">
          <tr class="task" [attr.data-workflow]="task.workflowInstanceId">
            <td>{{ formatSubject(task) }}</td>
            <td>{{ task.currentStepCode || "—" }}</td>
            <td data-testid="task-status">
              {{ formatWorkflowStatus(task.workflowStatusCode) }}
            </td>
            <td>{{ formatAssignmentPosture(task.assignmentPostureCode) }}</td>
            <td>
              {{
                task.currentAssigneeDisplayName ||
                  task.currentQueueDisplayText ||
                  "—"
              }}
            </td>
            <td>{{ task.statusChangedUtc | date: "short" }}</td>
            <td class="task__actions">
              <ng-container *ngIf="!isWorkflowCompleted(task); else doneCell">
                <span
                  *ngIf="pendingLegalReview(task)"
                  class="task__review-badge"
                  data-testid="legal-review-pending"
                  >Legal review pending</span
                >
                <span
                  *ngIf="pendingPostHearingApproval(task)"
                  class="task__review-badge"
                  data-testid="operations-review-pending"
                  >Operations approval pending</span
                >
                <button
                  type="button"
                  data-testid="claim-button"
                  (click)="claim(task)"
                  [disabled]="isActing()"
                >
                  Claim
                </button>
                <button
                  *ngIf="pendingLegalReview(task) && canReviewGrant()"
                  type="button"
                  data-testid="open-legal-review-button"
                  (click)="openLegalReview(task)"
                  [disabled]="isActing()"
                >
                  Open Legal review
                </button>
                <button
                  *ngIf="
                    pendingPostHearingApproval(task) && canApprovePostHearing()
                  "
                  type="button"
                  data-testid="approve-operations-review-button"
                  (click)="approvePostHearingCompletion(task)"
                  [disabled]="isActing() || !task.stepETag"
                >
                  {{ hearingText.approve() }}
                </button>
                <button
                  *ngIf="
                    canCompleteStep(task) &&
                    !pendingLegalReview(task) &&
                    !pendingPostHearingApproval(task)
                  "
                  type="button"
                  data-testid="complete-button"
                  (click)="complete(task)"
                  [disabled]="isActing()"
                >
                  Complete
                </button>
              </ng-container>
              <ng-template #doneCell>
                <span class="task__done" data-testid="task-completed"
                  >Completed</span
                >
              </ng-template>
            </td>
          </tr>
          <tr
            class="task__lifecycle-row"
            [attr.data-lifecycle]="task.workflowInstanceId"
          >
            <td colspan="7">
              <phms-case-lifecycle
                [workflowInstanceId]="task.workflowInstanceId"
                [currentStatus]="task.workflowStatusCode"
              ></phms-case-lifecycle>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</section>
